import { formatDurationFromSeconds } from '@/modules/analytics/utils/formatDuration';

/** Widest value the chart prints ("100%") at 12px, plus the inset on both sides. */
const MIN_INSIDE_WIDTH = 46;

/** Small non-zero shares must not read as "0%" — a bucket with calls in it never prints zero. */
export const formatBucketPercentage = (value: number): string => {
  if (!Number.isFinite(value) || value <= 0) {
    return '0%';
  }
  if (value < 1) {
    return '<1%';
  }
  return `${Math.round(value)}%`;
};

export const fitsInsideBar = (barWidth: number): boolean => barWidth >= MIN_INSIDE_WIDTH;

/** Whole minutes from a minute up ("20h 40m", "12m"), seconds below that. */
export const formatTotalDuration = (seconds: number): string =>
  formatDurationFromSeconds(seconds >= 60 ? Math.floor(seconds / 60) * 60 : seconds);
